import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2/Navbar2'
import Hero2 from '../../components/hero2/Hero2';
import About2 from '../../components/about2/about2';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import TeamSection from '../../components/TeamSection/TeamSection';
import PartnerSection from '../../components/PartnerSection/PartnerSection';

const HomePage2 = () => {
    return (
        <Fragment>
            <div className='page-wrapper'>
                <Navbar2 hclass={'header-style-2'} />
                <Hero2 />
                <About2 />
                <CtaSection />
                <TeamSection />
                <ProjectSection />               
                <PartnerSection />                             
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default HomePage2;